import store from '../../store'
import * as types from '../types'

export default function (promise, sid = null) {
    try {
        return new Promise((resolve, reject) => {
            try {
                promise()
                    .then(response => {
                        store.dispatch(types.errors.actions.forget, { sid })
                        resolve(response)
                    })
                    .catch(error => {
                        store.dispatch(types.errors.actions.store, { error, sid })
                        console.error(error)
                        reject(error)
                    })
            } catch (error) {
                store.dispatch(types.errors.actions.store, { error, sid })
                console.error(error)
                reject(error)
            }
        })
    } catch (error) {
        store.dispatch(types.errors.actions.store, { error, sid })
    }
}
